import { useEffect, useState } from "react";
import { Flame } from "lucide-react";

// Believable "sold today" count: seeded per-day, grows through the day,
// then ticks up live while the visitor is on the page.
function baseCountForToday() {
  const now = new Date();
  const dayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const seed = dayStart.getDate() * 7 + (dayStart.getMonth() + 1) * 3; // stable per day
  const fractionOfDay = (now - dayStart) / (24 * 60 * 60 * 1000); // 0 → 1
  const dailyTarget = 60 + (seed % 40); // 60–99 sales/day
  const start = 12 + (seed % 8); // morning starting point
  return Math.max(start, Math.round(start + fractionOfDay * dailyTarget));
}

export default function SoldTodayBadge({ className = "", testid = "sold-today-badge" }) {
  const [count, setCount] = useState(baseCountForToday);

  useEffect(() => {
    // Occasionally increment to feel "live" (every 25–55s).
    let timer;
    const tick = () => {
      setCount((c) => c + 1);
      timer = setTimeout(tick, 25000 + Math.random() * 30000);
    };
    timer = setTimeout(tick, 25000 + Math.random() * 30000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      data-testid={testid}
      className={`inline-flex items-center gap-2 text-sm text-[#353535] ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75"></span>
        <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-500"></span>
      </span>
      <Flame className="w-4 h-4 text-[#F59E0B]" />
      <span>
        <span data-testid="sold-today-count" className="font-bold text-[#232323]">{count}</span> sold today
      </span>
    </div>
  );
}
